import React, { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import apiService from '../../utils/api';
import './ProjectEmailPopup.css';
import Snackbar from '@mui/material/Snackbar';

const ProjectPopup = ({ isOpen, onClose,onSave,codePrefix = ''}) => {
  const [projectCode, setProjectCode] = useState('');   // <-- add this
  const [projectName, setProjectName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [userId, setUserId] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
const [snackbarMessage, setSnackbarMessage] = useState('');
const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    const storedUserId = sessionStorage.getItem('user_id') || '';
    setUserId(storedUserId);
  }, []);
   useEffect(() => {
  if (isOpen && codePrefix) {
    setProjectCode(codePrefix); // Start with prefix
  } else if (!isOpen) {
    setProjectCode('');
  }
}, [isOpen, codePrefix]);

  if (!isOpen) return null;

 

const handleSubmit = async (e) => {
  e.preventDefault();
  if (!projectName) { // Remove projectCode from required validation
    setSnackbarMessage("Please fill all required fields");
    setIsSuccess(false);
    setSnackbarOpen(true);
    return;
  }

  const payload = {
    user_id: userId,
    project_details: {
      projectName: projectName,
      projectCode: projectCode,
    },
  };

  console.log("Payload being sent:", payload);

  try {
    setIsLoading(true);

    const res = await apiService.postData("add_project", payload, true);
    console.log("Response from backend:", res);

    if (res?.status === "success") {
      const newProject = {
        id: res?.data?.id || res?.project?.id || Date.now().toString(),
        name: projectName,
        code: projectCode,
      };

      setProjectName('');
      setProjectCode('');

      if (onSave) {
        onSave(newProject);
      }

      setSnackbarMessage("Project added successfully");
      setIsSuccess(true);
      setSnackbarOpen(true);

      onClose();
    } else {
      setSnackbarMessage(res?.message || "Failed to save project");
      setIsSuccess(false);
      setSnackbarOpen(true);
    }
  } catch (error) {
    console.error("Error saving project:", error);
    setSnackbarMessage("Error saving project: " + error.message);
    setIsSuccess(false);
    setSnackbarOpen(true);
  } finally {
    setIsLoading(false);
  }
};
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="project-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="cbm-modal-header">
          <h2>Add New Project</h2>
          <button className="project-close-btn" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Project Name <span className="required-asterisk">*</span></label>
            <input
              type="text"
              value={projectName}
              onChange={(e) => setProjectName(e.target.value)}
              placeholder="Enter project name"
              required
            />
          </div>

          {/* <div className="form-group">
            <label>Project Code <span className="required-asterisk">*</span></label>
            <input
              type="text"
              value={projectCode}
              onChange={(e) => setProjectCode(e.target.value)}
              placeholder="Enter project code"
              required
            />
          </div> */}
        <div className="form-group">
  <label>Project Code</label>
  <div style={{ position: 'relative' }}>
    {/* Hidden prefix (for layout) */}
    <span
      style={{
        position: 'absolute',
        left: 0,
        top: 0,
        padding: '8px 12px',
        color: '#333',
        fontWeight: '600',
        pointerEvents: 'none',
        whiteSpace: 'nowrap',
        zIndex: 1,
        height: '90%',
        display: 'flex',
        alignItems: 'center'
      }}
    >
      {codePrefix || '—'}
    </span>

    {/* Editable input — starts after prefix */}
    <input
      type="text"
      value={projectCode.slice(codePrefix.length)}  // Only show suffix
      onChange={(e) => {
        const suffix = e.target.value;
        setProjectCode(codePrefix + suffix); // Full code = prefix + suffix
      }}
      onKeyDown={(e) => {
        // Prevent backspace from deleting prefix
        if (e.key === 'Backspace' && e.target.selectionStart === 0) {
          e.preventDefault();
        }
      }}
      placeholder="001"
      style={{
        paddingLeft: `calc(${codePrefix.length}ch + 24px + 12px)`, // Dynamic padding
        paddingRight: '12px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        width: '100%',
        height: '40px',
        fontSize: '14px',
        boxSizing: 'border-box'
      }}
    />
  </div>
</div>
          <div className="form-actions">
            <button type="submit" className="modal-action-btn modal-action-btn-save" disabled={isLoading}>
              {isLoading ? (
                <>
                  <CircularProgress size={20} style={{ marginRight: '8px', color: 'white' }} />
                  Saving...
                </>
              ) : (
                "Save"
              )}
            </button>
            <button
              type="button"
              className="modal-action-btn modal-action-btn-cancel"
              onClick={onClose}
              disabled={isLoading}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
      <Snackbar
  open={snackbarOpen}
  autoHideDuration={5000}
  onClose={() => setSnackbarOpen(false)}
  message={snackbarMessage}
  sx={{
    '& .MuiSnackbarContent-root': {
      backgroundColor: isSuccess ? '#4caf50' : '#f44336',
    },
    zIndex: 1400,
  }}
/>
    </div>
  );
};

export default ProjectPopup;
